import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'We stopped changing food every month.',
  initials: 'SM'
}, {
  text: 'The weekly tracking made everything clearer.',
  initials: 'CT'
}, {
  text: 'It finally feels predictable.',
  initials: 'AB'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-white" data-id="element-211">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-213">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1E293B]" data-id="element-214">
            Frenchie Owners Are Loving This
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-8" data-id="element-215">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#F8FAFC] rounded-xl p-6 border border-[#E2E8F0]" data-id="element-216">
              <div className="flex gap-1 mb-4" data-id="element-217">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-218" />)}
              </div>

              <p className="text-[#475569] text-lg leading-relaxed mb-6" data-id="element-219">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-3" data-id="element-220">
                <div className="w-10 h-10 rounded-full bg-[#E2E8F0] flex items-center justify-center text-sm font-semibold text-[#475569]" data-id="element-221">
                  {testimonial.initials}
                </div>
                <span className="text-sm text-[#94A3B8]" data-id="element-222">Verified Buyer</span>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-[#0F766E] font-semibold text-lg" data-id="element-223">
          A good routine changes everything.
        </motion.p>
      </div>
    </section>;
}